const getInboxesFromSelectedInboxes = (
  selectedInboxes: object,
): string[] => {
  return Object.keys(selectedInboxes).filter(
    (inbox) => !!selectedInboxes[inbox],
  );
};

export default getInboxesFromSelectedInboxes;
